import { createClientLogger } from "@/lib/logging/client";

const logger = createClientLogger("lib/nominatim");
// Nominatim API utility functions for location search
export interface NominatimPlace {
  place_id: string;
  name?: string;
  display_name: string;
  lat: string;
  lon: string;
  type: string;
  importance: number;
  address: {
    house_number?: string;
    road?: string;
    city?: string;
    state?: string;
    country?: string;
    country_code?: string;
    postcode?: string;
    suburb?: string;
  };
}

export async function searchPlaces(
  query: string,
  options?: { countryCode?: string; limit?: number },
): Promise<NominatimPlace[]> {
  if (!query || query.length < 2) return [];

  const { countryCode, limit = 5 } = options ?? {};

  try {
    let url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=${limit}&q=${encodeURIComponent(query)}`;

    if (countryCode) {
      url += `&countrycodes=${countryCode}`;
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Nominatim API error: ${response.status}`);
    }

    const data = await response.json();

    // Sort by importance
    const sortedResults = data.sort(
      (a: NominatimPlace, b: NominatimPlace) => b.importance - a.importance,
    );

    return sortedResults as NominatimPlace[];
  } catch (error) {
    logger.error("Error searching places:", error);
    return [];
  }
}

export async function getLocationDetails(
  lat: number,
  lon: number,
): Promise<NominatimPlace> {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1&limit=1&language=en`;
  const response = await fetch(url);
  const data = await response.json();
  return data as NominatimPlace;
}
